export default __webpack_public_path__ + "static/media/fallback-image.6932d846.png";